import {
  ArrowRightOutlined,
  HomeOutlined,
  UserOutlined,
} from "@ant-design/icons";

export const USER_SETTINGS_MENU_ITEMS = [
  {
    key: "1",
    title: "User profile",
    href: "/accounts/details",
    Icon: UserOutlined,
  },
  {
    key: "2",
    title: "Organization Settings",
    href: "/organization-settings/org-details",
    Icon: HomeOutlined,
  },
  {
    key: "5",
    title: "Log out",
    href: "/logout",
    Icon: ArrowRightOutlined,
  },
];
